import React from "react"
import { UseFormReturn } from "react-hook-form"
import { AdvancedSearchbar } from "components/advanced-searchbar/advanced-searchbar"
import {withUseFormHook} from "@sinossi/mates-react-library";
import {ContractRequest} from "../../../models";
import {ContractAdvancedSearchForm} from "./form";


interface ContractAdvancedSearchProps extends UseFormReturn
{
    onSearch: (request: ContractRequest) => void
}
class ContractAdvancedSearch extends React.Component<ContractAdvancedSearchProps, {}>
{

    private onSearch = (data: Record<string, any>): void => {
        const formData: ContractAdvancedSearchForm = new ContractAdvancedSearchForm()
        Object.assign(formData, data)

        const request: ContractRequest = formData.toRequest()
        this.props.onSearch(request)
    }

    render()
    {
        return (
            <AdvancedSearchbar
                {...this.props}
                searchFieldName="contractNumber"
                searchFieldPlaceholder="Ricerca per numero contratto"
                disableMenu
                onSearch={this.onSearch}>
            </AdvancedSearchbar>
        )
    }
}

export default withUseFormHook<{}>(ContractAdvancedSearch,{}, {})
